import { Component, OnInit } from '@angular/core';

import { UiService } from '../shared/services/ui.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.uiSrv.changeTitle("error.shortLabel");
    }

}
